import { ADMIN_USERNAME } from 'constants/admin';
import { ADMIN_LOGIN, LOGIN, LOGOUT } from 'store/actions/types';

let initialState = {
  username: sessionStorage.getItem('username'),
  isAuthenticated: sessionStorage.getItem('username') ? true : false,
  token: sessionStorage.getItem('token'),
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        username: action.payload.username,
        isAuthenticated: true,
        token: null,
      };
    case LOGOUT:
      return {
        ...state,
        username: null,
        isAuthenticated: false,
        token: null,
      };
    case ADMIN_LOGIN:
      return {
        ...state,
        username: ADMIN_USERNAME,
        isAuthenticated: true,
        token: action.payload.token,
      };
    default:
      return state;
  }
};

export default userReducer;
